"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/Wizard/Recipients/AddPatientsDialog.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);





var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _noticeBar = require('web/services/context/noticeBar');
var _campaignState = require('web/screens/Broadcast/campaignState');
var _format = require('web/screens/Broadcast/format');

var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _Form = require('web/components/Form');
var _WarningBar = require('web/components/WarningBar'); var _WarningBar2 = _interopRequireDefault(_WarningBar);
var _Spinner = require('web/components/Spinner');
var _Checkbox = require('web/screens/Broadcast/CampaignPage/Body/MessagesTable/components/Checkbox'); var _Checkbox2 = _interopRequireDefault(_Checkbox);
var _RecipientTable = require('web/screens/Broadcast/RecipientTable');
var _Table = require('web/screens/Directory/PatientTable/Table'); var _Table2 = _interopRequireDefault(_Table);
var _Toolbar = require('web/screens/Directory/PatientTable/Toolbar'); var _Toolbar2 = _interopRequireDefault(_Toolbar);
var _SelectionBar = require('web/screens/Directory/PatientTable/SelectionBar');
var _usePatientTable = require('web/screens/Directory/PatientTable/usePatientTable');



var _format3 = require('web/screens/Directory/PatientTable/format');



var _selection = require('web/screens/Directory/PatientTable/selection');
var _helpers = require('../helpers');
var _NewPatientForm = require('./NewPatientForm'); var _NewPatientForm2 = _interopRequireDefault(_NewPatientForm);



// The counts wait for ticking to settle.
const PREVIEW_DELAY_MS = 300
// Option A's columns: the patient table's, without Created and Last to patient.
const HIDDEN_COLUMNS = new Set(['created', 'lastTo'])
const NO_PENDING = new Map()
const noop = () => undefined












/* Which of the listed patients are already on the broadcast: the recipient
 * matching answers it like an Add would (already_in_campaign). A failed
 * check is shown with Try again, never read as "nobody" (D-85). */
const useAlreadyAdded = (campaignKey, keys) => {
  const request = keys.join(',')
  const [answer, setAnswer] = _react.useState(null)
  const [attempt, setAttempt] = _react.useState.call(void 0, 0)
  _react.useEffect.call(void 0, 
    () => {
      if (!request) return
      let isCurrent = true
      // SAFETY: request joins the listed PatientKeys.
      const asked = request.split(',') 
      _actions2.default.previewCampaignRecipients({
        CampaignKey: campaignKey,
        Sources: [{ Kind: 'rows', Rows: asked.map(PatientKey => ({ PatientKey, Values: {} })) }],
      })
        .then(({ Sources: [rows] }) => {
          if (!isCurrent) return
          if (_optionalChain([rows, 'optionalAccess', _ => _.Kind]) !== 'rows') {
            setAnswer({ request, keys: null })
            return
          }
          const added = rows.RowResults.flatMap(r => r.Match === 'already_in_campaign' && asked[r.Index] ? [asked[r.Index]] : [])
          setAnswer({ request, keys: new Set(added) })
        })
        .catch(() => { if (isCurrent) setAnswer({ request, keys: null }) })
      return () => { isCurrent = false }
    },
    [campaignKey, request, attempt],
  )
  const retry = _react.useCallback.call(void 0, () => setAttempt(n => n + 1), [])
  const current = _optionalChain([answer, 'optionalAccess', _2 => _2.request]) === request ? answer : null
  return {
    keys: _nullishCoalesce(_optionalChain([current, 'optionalAccess', _3 => _3.keys]), () => ( NONE_ADDED)),
    hasFailed: !!current && !current.keys,
    isChecked: !request || !!_optionalChain([current, 'optionalAccess', _4 => _4.keys]),
    retry,
  }
}
const NONE_ADDED = new Set()








/* What Add would do with the selection, once ticking settles: the Add
 * button's count and the sent warning come from it, so the count shown is
 * the count added. */
const usePreview = (orgKey, campaignKey, selection, shown) => {
  const asked = selection ? JSON.stringify(selection) : ''
  const request = asked && JSON.stringify({ Selection: selection, Shown: shown.length ? shown : undefined })
  const [preview, setPreview] = _react.useState(null)
  const [attempt, setAttempt] = _react.useState.call(void 0, 0)
  _react.useEffect.call(void 0, () => {
    if (!request) return
    let isCurrent = true
    const timer = setTimeout(
      () => _actions2.default.previewPatientPickForBroadcast({ OrgKey: orgKey, CampaignKey: campaignKey, ...JSON.parse(request)  })
        .then(counts => { if (isCurrent) setPreview({ asked, request, counts, error: null }) })
        .catch(e => { if (isCurrent) setPreview({ asked, request, counts: null, error: _helpers.errorText.call(void 0, e, 'Couldn\'t count the patients') }) }),
      PREVIEW_DELAY_MS,
    )
    return () => {
      isCurrent = false
      clearTimeout(timer)
    }
  }, [orgKey, campaignKey, asked, request, attempt])
  const refresh = _react.useCallback.call(void 0, () => setAttempt(n => n + 1), [])
  // Counts follow the selection; turning a page doesn't recount them.
  const isCurrent = !!preview && preview.asked === asked
  const chosen = _react.useMemo.call(void 0, 
    () => _optionalChain([preview, 'optionalAccess', _5 => _5.request]) === request && _optionalChain([preview, 'access', _6 => _6.counts, 'optionalAccess', _7 => _7.Chosen]) ? new Set(preview.counts.Chosen) : null,
    [preview, request],
  )
  return { counts: isCurrent ? preview.counts : null, error: isCurrent ? preview.error : null, chosen, refresh }
}

/* D-78, D-84: Add existing patients is the patient table in a dialog, with
 * its search, Filters and sort, and the selection both patient tables share
 * (direction C): the header checkbox ticks the page, "Select all N matching"
 * goes on to everyone matching (up to 20,000, D-48), and unticking after that
 * leaves a patient out. While anything is ticked the toolbar is the selection
 * bar, so the search and Filters wait for Clear (D-87). Hide already added
 * (on when it opens) leaves the broadcast's recipients out on the server;
 * off, they show ticked and greyed. New patient creates a patient here, who
 * comes back ticked. Add adds the lot through AddPatientPickToBroadcast;
 * nobody is asked for values (D-55): each of the message's variables takes
 * its default, and anyone left without one shows Missing value on
 * Recipients. While the Add runs the dialog can't close and the broadcast
 * counts as adding. */
const AddPatientsDialog = ({ isOpen, campaign, onClose }) => {
  const [isAdding, setIsAdding] = _react.useState.call(void 0, false)
  const [openCount, setOpenCount] = _react.useState.call(void 0, 0)
  const [wasOpen, setWasOpen] = _react.useState.call(void 0, isOpen)
  if (isOpen !== wasOpen) {
    setWasOpen(isOpen)
    if (isOpen) {
      setOpenCount(n => n + 1)
      setIsAdding(false)
    }
  }
  return (
    _react2.default.createElement(_Modal2.default, {
      isOpen: isOpen,
      title: "Add existing patients"  ,
      className: "broadcast-add-dialog broadcast-pick-dialog" ,
      bodyClassName: "broadcast-add-dialog--body broadcast-pick-dialog--body" ,
      onClose: isAdding ? undefined : onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 160}}

      , _react2.default.createElement(Picker, { key: openCount, campaign: campaign, isAdding: isAdding, onAdding: setIsAdding, onClose: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 167}} )
    )
  )
}

// A patient just created (or found by their contact) in New patient: listed
// first and ticked until the page, search or filters change.






const Picker




 = ({ campaign, isAdding, onAdding, onClose }) => {
  const { CampaignKey: campaignKey, OrgKey: orgKey } = campaign
  const { showSuccessBar } = _noticeBar.useNoticeBar.call(void 0, )
  const [isHidingAdded, setIsHidingAdded] = _react.useState.call(void 0, true)
  const broadcast = _react.useMemo.call(void 0, () => ({ campaignKey, isHidingAdded }), [campaignKey, isHidingAdded])
  const table = _usePatientTable.usePatientTable.call(void 0, orgKey, undefined, broadcast)
  const [selection, setSelection] = _react.useState(_selection.NO_SELECTION)
  const [error, setError] = _react.useState(null)
  const isAddingRef = _react.useRef.call(void 0, false)
  const [mode, setMode] = _react.useState('list')
  const [listedFirst, setListedFirst] = _react.useState(null)
  const [isCreating, setIsCreating] = _react.useState.call(void 0, false)
  const [createError, setCreateError] = _react.useState(null)

  const [tags, setTags] = _react.useState([])
  const loadTags = _react.useCallback.call(void 0, 
    () => _actions2.default.listPatientTags({ OrgKey: orgKey }).then(r => setTags(r.Tags)).catch(() => undefined),
    [orgKey],
  )
  _react.useEffect.call(void 0, () => { loadTags() }, [loadTags])

  // A new search, filter or Hide already added clears the selection (D-87).
  const { total, fullFilter, query } = table
  const scope = `${JSON.stringify(fullFilter)}|${isHidingAdded}`
  const [lastScope, setLastScope] = _react.useState.call(void 0, scope)
  if (scope !== lastScope) {
    setLastScope(scope)
    setSelection(_selection.NO_SELECTION)
    setListedFirst(null)
  }

  const first = listedFirst && listedFirst.page === table.page ? listedFirst.row : null
  const rows = _react.useMemo.call(void 0, 
    () => first ? [first, ...table.rows.filter(r => r.PatientKey !== first.PatientKey)] : table.rows,
    [first, table.rows],
  )
  const rowKeys = _react.useMemo.call(void 0, () => rows.map(r => r.PatientKey), [rows])
  const added = useAlreadyAdded(campaignKey, rowKeys)
  const selectable = _react.useMemo.call(void 0, () => rowKeys.filter(k => !added.keys.has(k)), [rowKeys, added.keys])
  const request = _react.useMemo.call(void 0, 
    () => _selection.hasAnything.call(void 0, selection) ? _selection.pickRequest.call(void 0, selection, fullFilter, table.sort, isHidingAdded) : null,
    [selection, fullFilter, table.sort, isHidingAdded],
  )
  // Which listed rows a Select all covers comes from the server, which caps
  // it in the table's sort (D-48): a row's place on a page can't say whether
  // it is inside the 20,000 once patients are left out (review F-1).
  const shown = _react.useMemo.call(void 0, () => selection.isAll ? rowKeys : [], [selection.isAll, rowKeys])
  const preview = usePreview(orgKey, campaignKey, request, shown)
  const isCapped = !!_optionalChain([preview, 'access', _8 => _8.counts, 'optionalAccess', _9 => _9.Capped])
  const isSelected = _react.useCallback.call(void 0, 
    (key) => preview.chosen && selection.isAll ? preview.chosen.has(key) : _selection.isChosen.call(void 0, selection, key),
    [preview.chosen, selection],
  )

  // Shift-click ticks or unticks the range from the last row changed (D-49).
  const anchor = _react.useRef(null)
  _react.useEffect.call(void 0, () => { anchor.current = null }, [rows])
  const onToggle = _react.useCallback.call(void 0, (key, isRange) => {
    if (isAdding || added.keys.has(key)) return
    const from = isRange && anchor.current ? rowKeys.indexOf(anchor.current) : -1
    const to = rowKeys.indexOf(key)
    const range = from >= 0 && to >= 0
      ? rowKeys.slice(Math.min(from, to), Math.max(from, to) + 1).filter(k => !added.keys.has(k))
      : [key]
    anchor.current = key
    const isOn = !isSelected(key)
    setSelection(s => _selection.setChosen.call(void 0, s, range, isOn, isCapped))
  }, [isAdding, added.keys, rowKeys, isSelected, isCapped])

  // The header checkbox ticks the page (D-84); its menu offers the page,
  // everyone matching, or nothing.
  const allSelection = _react.useMemo.call(void 0, () => _selection.pageState.call(void 0, selectable, isSelected), [selectable, isSelected])
  const onSelectAll = _react.useCallback.call(void 0, () => {
    if (!isAdding) setSelection(s => _selection.pressPage.call(void 0, s, selectable, allSelection.isChecked, isCapped))
  }, [isAdding, selectable, allSelection.isChecked, isCapped])
  const selectMatching = _react.useCallback.call(void 0, () => setSelection(_selection.selectAll), [])
  const clear = _react.useCallback.call(void 0, () => setSelection(_selection.NO_SELECTION), [])
  const selectMenu = _react.useMemo.call(void 0, () => ({
    pageCount: selectable.length,
    matchingCount: total,
    isDisabled: isAdding,
    onPage: () => setSelection(_selection.selectOnly.call(void 0, selectable)),
    onAll: selectMatching,
    onClear: clear,
  }), [selectable, total, isAdding, selectMatching, clear])

  const counts = preview.counts
  const hasStarted = _campaignState.hasCampaignStarted.call(void 0, campaign) || !!_optionalChain([counts, 'optionalAccess', _10 => _10.Sent])
  const newCount = _nullishCoalesce(_optionalChain([counts, 'optionalAccess', _11 => _11.New]), () => ( 0))
  const summary = _selection.selectionSummary.call(void 0, selection, total, selectable, isCapped)
  const justCreated = _optionalChain([listedFirst, 'optionalAccess', _12 => _12.isNew]) && !selection.isAll && selection.picked.size === 1 && selection.picked.has(listedFirst.row.PatientKey)
    ? `${listedFirst.row.Name}, just created`
    : undefined

  const add = () => {
    if (!request || !counts || isAddingRef.current) return
    isAddingRef.current = true
    onAdding(true)
    setError(null)
    const before = counts
    _actions2.default.addPatientPickToBroadcast({ OrgKey: orgKey, CampaignKey: campaignKey, Selection: request })
      .then(r => {
        const already = r.AlreadyOn ? `; ${_format3.formatCount.call(void 0, r.AlreadyOn)} already on it` : ''
        const cant = r.CantReceive ? `; ${_format3.formatCount.call(void 0, r.CantReceive)} can't receive texts and won't be texted` : ''
        showSuccessBar(`Added ${_format.pluralize.call(void 0, r.New, 'patient', 'patients')} to ${campaign.Name || 'the campaign'}${already}${cant}. Nothing was sent.`)
        onClose()
      })
      .catch(async (e) => {
        // Each 1,000 rows commit on their own, so a failure partway keeps
        // what was written: the next count says how many are no longer new.
        // At the cap with Hide already added on, the next patients in the
        // sort take their places, so it can't say.
        const after = await _actions2.default.previewPatientPickForBroadcast({ OrgKey: orgKey, CampaignKey: campaignKey, Selection: request })
          .catch(() => null)
        const landed = after ? before.New - after.New : 0
        setError(landed > 0
          ? `${_format.pluralize.call(void 0, landed, 'patient was', 'patients were')} added before the add failed. Add again to add the rest; anyone already added is skipped.`
          : after && !before.Capped
            ? _helpers.errorText.call(void 0, e, 'Couldn\'t add the patients. Nothing was added')
            : 'Couldn\'t add the patients. Some may have been added; adding again skips anyone already on the campaign.')
        preview.refresh()
      })
      .finally(() => {
        isAddingRef.current = false
        onAdding(false)
      })
  }

  // New patient (D-84): the patient comes back listed first and ticked.
  const listFirst = _react.useCallback.call(void 0, (row, isNew) => {
    setListedFirst({ row, isNew, page: table.page })
    setSelection(s => _selection.setChosen.call(void 0, s, [row.PatientKey], true))
    setCreateError(null)
    setMode('list')
  }, [table.page])
  const readRow = _react.useCallback.call(void 0, 
    (patientKey) => _actions2.default.getPatientTableRow({ OrgKey: orgKey, PatientKey: patientKey }).then(r => r.Patient),
    [orgKey],
  )
  const create = (fields, tagValue) => {
    setIsCreating(true)
    setCreateError(null)
    _actions2.default.createPatient({
      OrgKey: orgKey,
      FirstName: fields.FirstName.trim(),
      LastName: fields.LastName.trim(),
      DateOfBirth: fields.DOB,
      Phone: fields.Phone.trim(),
      Email: fields.Email.trim(),
      ForeignID: fields.MRN.trim(),
      TagKeys: tagValue.TagKeys,
      NewTagNames: tagValue.NewNames,
    })
      .then(({ Patients }) => {
        // A new tag joins the org's list (the filters and the next form).
        if (tagValue.NewNames.length > 0) loadTags()
        // SAFETY: NewPatient answers with the created patient, keyed by PatientKey.
        const [patientKey] = Object.keys(Patients) 
        if (!patientKey) throw new Error('No patient came back')
        return readRow(patientKey)
      })
      .then(row => listFirst(row, true))
      .catch(e => setCreateError(_helpers.errorText.call(void 0, e, 'Couldn\'t create the patient')))
      .finally(() => setIsCreating(false))
  }
  const selectExisting = (patient) => {
    setIsCreating(true)
    readRow(patient.PatientKey)
      .then(row => listFirst(row, false))
      .catch(e => setCreateError(_helpers.errorText.call(void 0, e, 'Couldn\'t find that patient')))
      .finally(() => setIsCreating(false))
  }

  if (mode === 'new') {
    return (
      _react2.default.createElement(_NewPatientForm2.default, {
        campaignKey: campaignKey,
        isCreating: isCreating,
        error: createError,
        onBack: () => {
          setCreateError(null)
          setMode('list')
        },
        tags: tags,
        onCreate: create,
        onUseExisting: selectExisting, __self: this, __source: {fileName: _jsxFileName, lineNumber: 360}}
      )
    )
  }

  const description = _format3.describeFilter.call(void 0, fullFilter, tags)
  const isFiltered = !!query || _format3.hasFilters.call(void 0, fullFilter)
  const clearSearchAndFilters = () => {
    table.setSearch('')
    table.setFilter({})
  }
  let emptyState
  if (table.hasError) emptyState = _react2.default.createElement('span', { className: "recipients-screen--no-match", __self: this, __source: {fileName: _jsxFileName, lineNumber: 382}}, "No patients to show."   )
  else if (!table.hasLoaded || table.isLoading) emptyState = _react2.default.createElement(_Spinner.SimpleSpinner, { className: "campaign--table--spinner", __self: this, __source: {fileName: _jsxFileName, lineNumber: 383}} )
  else if (isHidingAdded && table.addedCount > 0) {
    emptyState = (
      _react2.default.createElement(_react2.default.Fragment, null
        , _react2.default.createElement('span', { className: "recipients-screen--no-match", __self: this, __source: {fileName: _jsxFileName, lineNumber: 387}}
          ,  isFiltered ? 'Everyone matching is already in this campaign.' : 'Everyone is already in this campaign.' 
        )
        , _react2.default.createElement('button', { type: "button", className: "dir-link", onClick: () => setIsHidingAdded(false), __self: this, __source: {fileName: _jsxFileName, lineNumber: 390}}, "Show them" )
      )
    )
  } else if (isFiltered) {
    emptyState = (
      _react2.default.createElement(_react2.default.Fragment, null
        , _react2.default.createElement('span', { className: "recipients-screen--no-match", __self: this, __source: {fileName: _jsxFileName, lineNumber: 396}}
          ,  query ? `No active patients match "${query}".` : 'No active patients match these filters.' 
        )
        , _react2.default.createElement('button', { type: "button", className: "dir-link", onClick: clearSearchAndFilters, __self: this, __source: {fileName: _jsxFileName, lineNumber: 399}}, "Clear search and filters"   )
      )
    )
  } else emptyState = _react2.default.createElement('span', { className: "recipients-screen--no-match", __self: this, __source: {fileName: _jsxFileName, lineNumber: 402}}, "No patients yet."  )

  const from = table.page * _format3.PAGE_SIZE + 1
  const to = table.page * _format3.PAGE_SIZE + table.rows.length
  // Archived patients are never listed or added (D-21); with Hide already
  // added on, nor are the broadcast's recipients. The footer says how many
  // the list leaves out for each (c-pk1, x-pk4on, x-pk4off).
  const addedText = table.addedCount > 0 ? `${_format3.formatCount.call(void 0, table.addedCount)} already in this campaign` : ''
  const archivedText = table.archivedCount > 0
    ? _format.pluralize.call(void 0, table.archivedCount, isFiltered ? 'matching archived patient' : 'archived patient', isFiltered ? 'matching archived patients' : 'archived patients')
    : ''
  const leftOutNote = isHidingAdded
    ? [addedText, archivedText].filter(Boolean).join(' and ')
    : addedText
  const notListed = isHidingAdded
    ? (leftOutNote ? ` · ${leftOutNote} not listed` : '')
    : `${addedText ? ` · ${addedText}` : ''}${archivedText ? ` · ${archivedText} not listed` : ''}`

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement('div', { className: "dir-table-page broadcast-pick" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 422}}
        ,  _selection.hasAnything.call(void 0, selection)
          ? (
              _react2.default.createElement('div', { role: "toolbar", 'aria-label': "Selected patients" , className: "recipients-toolbar recipients-toolbar--selection dir-selection"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 425}}
                , _react2.default.createElement(_SelectionBar.SelectionSummary, { summary: summary, extra: justCreated, isDisabled: isAdding, onSelectAll: selectMatching, onClear: clear, __self: this, __source: {fileName: _jsxFileName, lineNumber: 426}} )
              )
            )
          : (
              _react2.default.createElement(_Toolbar2.default, {
                view: "active",
                onView: noop,
                activeCount: table.activeCount,
                archivedCount: table.archivedCount,
                search: table.search,
                onSearch: table.setSearch,
                filter: table.filter,
                onFilter: table.setFilter,
                tags: tags,
                hiddenColumns: HIDDEN_COLUMNS,
                onToggleColumn: noop,
                hasCounts: table.hasLoaded,
                onOpenFilters: loadTags,
                isSearchOnly: true,
                beforeFilters: (
                  _react2.default.createElement('div', { className: "broadcast-pick--hide", __self: this, __source: {fileName: _jsxFileName, lineNumber: 446}}
                    , _react2.default.createElement(_Checkbox2.default, { isChecked: isHidingAdded, label: "Hide already added"  , onChange: setIsHidingAdded, __self: this, __source: {fileName: _jsxFileName, lineNumber: 447}} )
                    , _react2.default.createElement('button', { type: "button", className: "broadcast-pick--hide-label", onClick: () => setIsHidingAdded(h => !h), __self: this, __source: {fileName: _jsxFileName, lineNumber: 448}}, "Hide already added"

                    )
                    /* Its place is kept while the count loads, so the search doesn't shift (rev 4 QA F-6). */
                    , _react2.default.createElement('span', { className: _classBuilder2.default.call(void 0, 'broadcast-pick--hide-count', !table.hasLoaded && 'broadcast-pick--hide-count-pending'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 452}}
                      ,  table.hasLoaded ? _format3.formatCount.call(void 0, table.addedCount) : '0' 
                    )
                  )
                ),
                afterFilters: (
                  _react2.default.createElement('button', { type: "button", className: "blm-btn blm-btn--secondary dir-toolbar--btn"  , onClick: () => setMode('new'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 458}}
                    , _react2.default.createElement('img', { alt: "", src: "/assets/icons/add-participant-black.svg", __self: this, __source: {fileName: _jsxFileName, lineNumber: 459}} ), "New patient"

                  )
                ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 430}}
              )
            )
        ,  table.hasError && (
          _react2.default.createElement(_WarningBar2.default, { theme: "warning", className: "dir-warning", linkText: "Try again" , onLinkClick: table.reload, __self: this, __source: {fileName: _jsxFileName, lineNumber: 466}}
            , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 467}}, "Patients couldn't load."  ), " Check your connection; nothing was changed."
          )
        )
        ,  added.hasFailed && !table.hasError && (
          _react2.default.createElement(_WarningBar2.default, { theme: "warning", className: "dir-warning", linkText: "Try again" , onLinkClick: added.retry, __self: this, __source: {fileName: _jsxFileName, lineNumber: 471}}
            , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 472}}, "Couldn't check who is already on this campaign."       ), " Add waits until the check works."
          )
        )
        , _react2.default.createElement(_Table2.default, {
          view: "active",
          hiddenColumns: HIDDEN_COLUMNS,
          rows: table.hasError ? [] : rows,
          sort: table.sort,
          onSort: table.onSort,
          isSelected: isSelected,
          onToggle: onToggle,
          allSelection: allSelection,
          onSelectAll: onSelectAll,
          selectMenu: selectMenu,
          emptyState: emptyState,
          isBusy: table.isLoading,
          pending: NO_PENDING,
          added: added.keys,
          markedNew: _optionalChain([listedFirst, 'optionalAccess', _13 => _13.isNew]) ? listedFirst.row.PatientKey : null,
          label: "Patients to add"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 475}}
        )
        ,  table.hasLoaded && !table.hasError && (
          _react2.default.createElement('div', { className: "dir-footer", __self: this, __source: {fileName: _jsxFileName, lineNumber: 494}}
            , _react2.default.createElement('span', { className: "dir-footer--count", __self: this, __source: {fileName: _jsxFileName, lineNumber: 495}}
              ,  total > 0
                ? _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 497}},  _format3.formatCount.call(void 0, from) , "–",  _format3.formatCount.call(void 0, to) ), " of "  , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 497}},  _format3.formatCount.call(void 0, total) ), " " ,  _format3.patientsNoun.call(void 0, total, false, description) )
                : _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 498}}, "0"), " " ,  _format3.patientsNoun.call(void 0, 0, false, description) )
              
              ,  notListed 
            )
            , _react2.default.createElement(_RecipientTable.RecipientPager, { page: table.page, pageCount: Math.ceil(total / _format3.PAGE_SIZE), onPage: table.setPage, __self: this, __source: {fileName: _jsxFileName, lineNumber: 502}} )
          )
        )
      )
      ,  hasStarted && _selection.hasAnything.call(void 0, selection) && (
        _react2.default.createElement('div', { role: "status", className: "recipients-notice broadcast-pick--sent" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 507}}
          , _react2.default.createElement('span', { className: "recipients-notice--icon", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 508}}, "⚠")
          , _react2.default.createElement('span', { className: "recipients-notice--text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 509}}
            , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 510}},  campaign.Name || 'This campaign' , " has already gone out."    ), " Adding patients doesn't text them. Only the patients you add are texted, and only when someone sends to them."
          )
        )
      )
      ,  (error || preview.error) && (
        _react2.default.createElement('p', { role: "alert", className: "broadcast-wizard--error broadcast-add-dialog--error" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 515}},  error || preview.error )
      )
      , _react2.default.createElement('div', { className: "broadcast-upload-dialog--foot broadcast-pick--foot" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 517}}
        , _react2.default.createElement('span', { className: "broadcast-wizard--grow", __self: this, __source: {fileName: _jsxFileName, lineNumber: 518}} )
        , _react2.default.createElement(_Form.Button, { isSecondary: true, isDisabled: isAdding, onClick: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 519}}, "Cancel")
        , _react2.default.createElement(_Form.Button, {
          isDisabled: !counts || newCount === 0 || table.hasError || added.hasFailed || !added.isChecked,
          isLoading: isAdding,
          onClick: add, __self: this, __source: {fileName: _jsxFileName, lineNumber: 520}}

          /* While a selection is counted, the button says so (rev 4 QA round 2). */
          ,  counts && newCount > 0
            ? `Add ${_format.pluralize.call(void 0, newCount, 'patient', 'patients')}`
            : _selection.hasAnything.call(void 0, selection) && !counts && !preview.error ? 'Counting…' : 'Add patients' 
        )
      )
    )
  )
}

exports. default = _react.memo.call(void 0, AddPatientsDialog)
